/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_CompletedInputs */

const en_case_history_verb_task_completed = /** @type {(inputs: Case_History_Verb_Task_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completed`)
};

const pt_br2_case_history_verb_task_completed = /** @type {(inputs: Case_History_Verb_Task_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`concluída`)
};

/**
* | output |
* | --- |
* | "completed" |
*
* @param {Case_History_Verb_Task_CompletedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_completed = /** @type {((inputs?: Case_History_Verb_Task_CompletedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_CompletedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_completed(inputs)
	return pt_br2_case_history_verb_task_completed(inputs)
});